export default __webpack_public_path__ + "static/media/vehicleand.9acfdbaf.png";